import styled from "styled-components";
import { device } from "../device";

export const GridContainer = styled.div`
  box-sizing: border-box;
  max-width: 1440px;
  width: 100%;
  display: grid;
  grid-gap: 15px;
  padding: 28px 15px;
  /* margin: 28px auto; */
  margin: auto;
  grid-template-columns: repeat(12, 1fr);
  align-items: start;

  @media ${device.tablet} {
    grid-gap: 20px;
    padding: 48px 20px;
    /* margin: 48px auto; */
  }
  @media ${device.laptop} {
    grid-gap: 25px;
    padding: 64px 25px;
    /*  margin: 64px auto; */
  }
`;
export interface GridItemProps {
  color?: string;
  span?: number;
}
export const GridItem = styled.div<GridItemProps>`
  grid-column: span ${(props) => (props.span != null ? props.span : 12)};
  background-color: ${(props) => (props.color ? props.color : "#FFFFFF")};
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 30px;
  z-index: 0;
`;
